// TES-1034 S7 (Emelie, points 1-2) — the transfer review's Webdoc step.
// Every decision on the review, whatever its outcome, is sent with the
// confirmation that the compiled journal note is entered in Webdoc (Ö-284
// (a)); a decision that asks for a new blood test also confirms the remiss.
// The API refuses a decision without the journal tick and stores the note's
// final version and receipt with it.
//
// Pure on purpose: no React, no path aliases (`node --test`).
import type { WebdocControl } from "@care-by-ella/contracts";
import { requisitionRefControl } from "./requisition-ref";

export function transferWebdocControl(s: {
  journalDone: boolean;
  needsLabOrder: boolean;
  labOrderDone: boolean;
  /** TES-442 — "Remissnummer i Webdoc (valfritt)", as typed. */
  requisitionRef?: string;
}): WebdocControl {
  return {
    journalInWebdoc: s.journalDone,
    ...(s.needsLabOrder ? { labOrderDoneInWebdoc: s.labOrderDone } : {}),
    ...requisitionRefControl(s),
  };
}
